// All code in this file and other files within the `../worker` folder is
// copied/derived from the following tutorial:
// https://dev.to/cchanxzy/use-web-workers-in-create-react-app-without-ejecting-and-typescript-2ap5

// Inline loader so that we don't have to eject and modify webpack config
// eslint-disable-next-line
import Worker from "comlink-loader!./worker";

export default Worker;
